import React, { memo, useCallback, useState } from 'react';

import { Input, version2 } from 'ui-components/components/input';
import { MDash } from 'ui-components/components/mdash/mdash';

import { areProductPropsEqual } from '../utils';
import styles from './styles.module.less';

/**
 * @param {import('../../../types').ColumnProps} props
 * @returns {React.ReactNode}
 */
const Column = ({ value }) => {
  const { product, updateProduct } = value;
  const [lot, setLot] = useState(product.lotId);

  const onBlur = useCallback(() => {
    updateProduct(product.rowKey ?? String(product.productId), 'lotId', lot);
  }, [lot, product.rowKey, product.productId, updateProduct]);

  const onChange = useCallback((e) => {
    setLot(e.target.value);
  }, []);

  if (product.isBundle) {
    return <MDash />;
  }

  return <Input className={styles['lot-input']} onBlur={onBlur} onChange={onChange} value={lot} version={version2} />;
};

export const LotIdColumn = memo(Column, areProductPropsEqual('lotId'));
